"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Training = exports.TrainingQuestion = exports.TrainingAnswer = exports.TrainingPage = exports.TrainingCertificateSummary = exports.TrainingCertificate = void 0;
class TrainingCertificate {
}
exports.TrainingCertificate = TrainingCertificate;
class TrainingCertificateSummary {
}
exports.TrainingCertificateSummary = TrainingCertificateSummary;
class TrainingPage {
}
exports.TrainingPage = TrainingPage;
class TrainingAnswer {
}
exports.TrainingAnswer = TrainingAnswer;
class TrainingQuestion {
}
exports.TrainingQuestion = TrainingQuestion;
class Training {
}
exports.Training = Training;
//# sourceMappingURL=training.js.map